var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "bi", class: _vm.inline ? "bi-inline" : "bi-block" },
    [
      _c("span", { staticClass: "bi-zh" }, [_vm._v(_vm._s(_vm.zh))]),
      _vm.pt
        ? _c("span", { staticClass: "bi-pt" }, [_vm._v(_vm._s(_vm.pt))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }